import { css } from '@emotion/css'
import { borderRadius, spacing, fontFamily, fontSize, zIndex } from '../../styles'
import { spin } from '../../styles/animations'
import { shorthandHelper } from '../../styles/helpers'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  container: css({
    width: 240,
  }),

  wrapper: css({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    height: 40,
    width: '100%',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level5,
    backgroundColor: colors.white,
  }),

  input: css({
    boxSizing: 'border-box',
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 44, spacing.small, spacing.default]),
    color: colors.jumbo,
    backgroundColor: 'transparent',
    border: 0,
    borderRadius: borderRadius.default,
    flex: 1,
    height: '100%',

    '&::placeholder': {
      color: colors.grayChateau,
      userSelect: 'none',
    },

    '&:focus': {
      outline: 'none',
    },

    '&[readOnly]': {
      backgroundColor: colors.athensGray,

      '& + div': {
        pointerEvents: 'none',
      },
    },
  }),

  icon: css({
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: 'none',
  }),

  iconClear: css({
    cursor: 'pointer',
    pointerEvents: 'auto',
  }),

  iconSpinning: css({
    animationName: spin,
    animationDuration: '2000ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
  }),

  body: css({
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: 'auto',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    listStyle: 'none',
    margin: 0,
    padding: 0,
    zIndex: zIndex.level6,
    marginTop: -1,
    borderTopColor: 'transparent',
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
  }),

  item: css({
    fontFamily: fontFamily.body,
    backgroundColor: colors.white,
    display: 'flex',
    padding: spacing.default,

    '&:hover': {
      cursor: 'pointer',
    },
  }),
}

export default styles

export const autoSuggest = {
  container: css({
    position: 'relative',
  }),

  suggestionsList: css({
    listStyle: 'none',
    padding: 0,
  }),

  suggestion: css({
    fontSize: fontSize.default,
    lineHeight: 1.2,
    color: colors.jumbo,
    padding: 0,
  }),
}

export const wrapperTheme = (theme, readOnly, focused) => {
  const themed = getThemeColors(theme)
  return css({
    ...(readOnly && {
      pointerEvents: 'none',
    }),

    ...(!readOnly &&
      focused && {
        borderColor: themed.base,
        boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
      }),
  })
}

export const wrapperError = focused =>
  css({
    borderColor: colors.mandy,
    ...(focused && {
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`,
    }),
  })

export const itemTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    color: themed.base,
    backgroundColor: themed.light,
  })
}
